export default "__VITE_ASSET__526635df__"